(() => {
  if (customElements.get('ts-lug-count-help')) return;
  class LugCountHelp extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.ts-lug-help__trigger');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.querySelector('[data-lug-close]').focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-lug-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }, options);
    }
    restore() {
      if (this.previousOverflow !== undefined) document.body.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
      if (this.previousFocus && this.previousFocus.isConnected) this.previousFocus.focus({ preventScroll: true });
      this.previousFocus = null;
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.restore();
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  }
  customElements.define('ts-lug-count-help', LugCountHelp);
})();
